import axios from './_nestAxios'

// Reporte logic

export const descargarReporteComparativo = params =>
  axios.get('/presupuestos-nuevo/descargar-reporte-comparativo', { responseType: 'blob', params })

export const descargarReporteBaseProductoServicio = () =>
  axios.get('/presupuestos-nuevo/descargar-reporte-producto-servicio', { responseType: 'blob' })

export const descargarReporteBaseCuentaContable = () =>
  axios.get('/presupuestos-nuevo/descargar-reporte-cuenta-contable', { responseType: 'blob' })
